import { Component, OnInit } from '@angular/core';
import { BaseEntity, BaseInlineContainer, InlineContainerService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { List } from 'immutable';

@Component({
  selector: 'yt-fin-dokument-stavka-update-container',
  templateUrl: './fin-dokument-stavka-update-container.component.html',
  providers: [
    InlineContainerService
  ]
})
export class FinDokumentStavkaUpdateContainer<T extends BaseEntity> extends BaseInlineContainer<T> {

  constructor(inlineContainerService: InlineContainerService<T>,
    activatedRoute: ActivatedRoute,
    userService: UserService){
super(inlineContainerService, activatedRoute, userService);
}

tempItems: List<T>

setItems(items){
this.tempItems = items;
}

}
